{
    "SidebarMenu_Reporting_Reporting": "Analytique",
    "SidebarMenu_Reporting_Insights": "Connaissances",
    "SidebarMenu_Reporting_Presence": "Présence",
    "SidebarMenu_FastProvisioning_EnterpriseManagement": "Ajouter une entreprise +",
    "SidebarMenu_FastProvisioning_UserManagement": "Gestion des utilisateurs",
    "SidebarMenu_FastProvisioning_QueueManagement": "Gestion des files d'attente",
    "SidebarMenu_Admin_Devices": "Appareils",
    "SidebarMenu_Admin_Agents": "Agents",
    "SidebarMenu_Admin_Directory": "Annuaire",
    "SidebarMenu_Admin_Codes": "Codes",
    "SidebarMenu_Admin_Partitions": "Cloisons",
    "SidebarMenu_Admin_TelephonyServers": "Serveurs de téléphonie",
    "SidebarMenu_Admin_CME": "FMC",
    "SidebarMenu_Admin_AppUsers": "Utilisateurs",
    "SidebarMenu_Admin_Recording": "Enregistrement",
    "SidebarMenu_Admin_Messages": "Messages",
    "SidebarMenu_Admin_Database": "Base de données",
    "SidebarMenu_StatusTools_Licences": "Licences",
    "SidebarMenu_StatusTools_Logging": "Enregistrement",
    "SidebarMenu_StatusTools_LogManagement": "Gestion des journaux",
    "SidebarMenu_StatusTools_AuditTrail": "Piste d'audit",
    "SidebarMenu_StatusTools_TelephoneModuleStatus": "État du module TelSys",
    "SidebarMenu_StatusTools_CallControl": "Contrôle des appels",
    "SidebarMenu_StatusTools_ServerStatus": "État du serveur",
    "NAME": "SidebarMenu",
    "SidebarMenu_Admin_ClientConfig": "Configuration du client",
    "SidebarMenu_Admin_CRM_Configuration": "Intégration CRM",
    "SidebarMenu_Reporting_CXScore": "Score CX",
    "SidebarMenu_Admin_Overview": "Aperçu"
}